import {directive as onClickaway} from 'vue-clickaway';
import {mapGetters} from "vuex";

export default {
    name: 'auth-social',
    directives: {
        onClickaway: onClickaway,
    },
    computed: {
        ...mapGetters({
            currentCountry: 'setting/currentCountry',
        })
    },
    data() {
        return {
            active: false,
        }
    },
    methods: {
        close() {
            this.active = false;
        }
    }
}
